export default __webpack_public_path__ + "static/logo-white-ca60299378f086be38fd467ddd8bbc41.svg";